import React from 'react';
import { connect, useDispatch } from 'react-redux';

import i18n from 'utils/I18n';

import { createAction } from 'utils';

import './ActivityLoginReachLimitContent.scss';
import LoadMoreSpinner from 'component/common/LoadMoreSpinner';

const mapStateToProps = (state) => ({
  activityLogDetail: state.activityLogs.activityLogDetail,
});

const ActivityLoginReachLimitContent = ({
  activityLogId,
  activityLogDetail,
}) => {
  const dispatch = useDispatch();

  console.log('data', activityLogDetail);
  React.useEffect(() => {
    dispatch(
      createAction('activityLogs/userActivityLogDetail')({
        id: activityLogId,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityLogId]);

  if (!activityLogDetail?.activityId) {
    return <div className='activity-log-reach-limit-loading'>
      <LoadMoreSpinner />
    </div>
  }

  return (
    <div className="activity-log-reach-limit-content">
      <div className="reach-limit-head">
        <div className="title2 body-1">
          {activityLogDetail?.rewardLimitDetail?.title}
        </div>
        {activityLogDetail?.transactionInfo?.date ? (
          <div className="title3 body-1">
            {i18n.t('records:transaction_date')}:{' '}
            {activityLogDetail?.transactionInfo?.date}
          </div>
        ) : null}
      </div>
      <div className="error-list">
        {activityLogDetail?.rewardLimitDetail?.errors?.map((item, index) => {
          if (!item?.showItem) {
            return null;
          }
          return (
            <div key={index} className="error-item">
              <div
                className={
                  item?.isPrimary ? 'body-1 error-primary' : 'body-1 error-g3'
                }
              >
                {item.title}
              </div>
              <div className="error-values">
                {item.boldValues?.map((value, index) => (
                  <div
                    key={`bold-${index}`}
                    className={
                      item?.isPrimary
                        ? 'body-2 error-primary'
                        : 'body-2 error-g1'
                    }
                  >
                    {value}
                  </div>
                ))}
                {item.normalValues?.map((value, index) => (
                  <div
                    key={`normal-${index}`}
                    className={
                      item?.isPrimary
                        ? 'body-1 error-primary'
                        : 'body-1 error-g3'
                    }
                  >
                    {value}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      <div className="tag-menu-1 error-g3">
        {i18n.t('records:reward_limit_reached_tip')}
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(ActivityLoginReachLimitContent);
